import { styled } from '@mui/material';

const Footer = styled('footer')`
  height: 40px;
  background: black;
`;

export default Footer;
